import { useContext, useEffect, useState } from "react";
import { Context } from "../../../context/Context";
import { Button } from "../../ui";
import { fetchAppSendHistoryAPI } from "../../../utils/api/menuAppSend";
import { integrationLabel } from "../../../utils/integrations";
import { menuErrorMessage } from "../menuRole";
import { sendToAppText } from "./sendToAppText";

// Immutable "Send Items to App" events of one item (newest first). Editing the
// item never changes these records; `isCurrentVersion` tells whether that send
// carried the item's current content.
export default function SendHistoryDialog({ menuId, item, onClose }) {
  const { lang } = useContext(Context);
  const t = sendToAppText(lang);
  const [state, setState] = useState({ loading: true, events: [], error: "" });

  useEffect(() => {
    let alive = true;
    fetchAppSendHistoryAPI(menuId, item._id)
      .then((events) => alive && setState({ loading: false, events, error: "" }))
      .catch((error) => alive && setState({ loading: false, events: [], error: menuErrorMessage(error, lang) || t.historyFailed }));
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuId, item._id]);

  const name = item.name?.[lang] || item.name?.ar || item.name?.en || "";
  const date = (value) => new Date(value).toLocaleString(lang === "ar" ? "ar-SA" : "en-GB", { dateStyle: "medium", timeStyle: "short" });

  return (
    <div className="food-modal-overlay">
      <div className="food-modal send-history" role="dialog" aria-modal="true" aria-label={t.historyTitle(name)}>
        <h3>{t.historyTitle(name)}</h3>
        {state.loading && <p>{t.historyLoading}</p>}
        {state.error && <p role="alert">{state.error}</p>}
        {!state.loading && !state.error && state.events.length === 0 && <p>{t.historyEmpty}</p>}
        <ul className="send-history-list">
          {state.events.map((event) => {
            const mine = event.items.find((entry) => entry.itemId === String(item._id)) || event.items[0];
            return (
              <li key={event.requestId}>
                <strong>{date(event.sentAt)}</strong>
                <span>{t.historyAction(event.action || "update", integrationLabel(event.app, lang))}</span>
                <span>
                  {t.reference}: <code>{event.requestId}</code>
                </span>
                {event.sentBy && (
                  <span>
                    {t.sentBy}: {event.sentBy}
                  </span>
                )}
                {event.itemCount > 1 && <span>{t.itemsInSend(event.itemCount)}</span>}
                {mine?.isCurrentVersion !== null && mine?.isCurrentVersion !== undefined && <span className={`send-history-version ${mine.isCurrentVersion ? "current" : "older"}`}>{mine.isCurrentVersion ? t.currentVersion : t.olderVersion}</span>}
              </li>
            );
          })}
        </ul>
        <div className="food-modal-actions">
          <Button type="button" variant="warning" appearance="soft" onClick={onClose}>
            {t.close}
          </Button>
        </div>
      </div>
    </div>
  );
}
